import { Component, OnInit, ViewChild } from '@angular/core';
import { ReportService } from '../services/report.service';
import { EmsdashboardService } from '../services/emsdashboard.service';
import { DeviceMasterService } from '../services/device-master.service';
import { TransformerManagerService } from '../services/transformerManager.service';
import { MatPaginator, MatSort, MatTableDataSource, MatDialog, MatDialogConfig } from '@angular/material'
import { CustomDateComponent } from '../reports/customdate/custom-date.component';
import * as pdfMake from 'pdfmake/build/pdfmake';
import * as pdfFonts from 'pdfmake/build/vfs_fonts';
pdfMake.vfs = pdfFonts.pdfMake.vfs;
@Component({
  selector: 'app-emsalertreport',
  templateUrl: './emsalertreport.component.html',
  styleUrls: ['./emsalertreport.component.scss']
})
export class EmsalertreportComponent implements OnInit {
  deviceIds: any = [];
  parameters: any = ['All','Low Power Factor'];
  reportColumns: string[] = ['Date', 'deviceid','energyMeterId', 'parametername', 'thresholdvalue', 'actualvalue'];
  reportData: any[];
  selectedparameter: string;
  selectedDevice;
  dataSource;
  customDateRange;
  startdate;
  enddate;
  customeSelectedDate: any;
  selectedEnergyMeter;
  meterSerialNumber;
  device;
  meterid;
  timeOptions: any = ['Today', 'Yesterday', 'This Week', 'This Month', 'Last Month', 'Custom'];
  timeFilter: string;
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;
  constructor(private matDialog: MatDialog, private transMngSer: TransformerManagerService, private deviceManagerSer: DeviceMasterService, private reportService: ReportService, private EmsdashboardService: EmsdashboardService,) { }

  async ngOnInit() {

    this.deviceManagerSer.getEMSDeviceId(JSON.parse(localStorage.getItem('userData')).userid).subscribe((response: any) => {
      let Deviceids = []
      response.result.forEach(function (value) {
        Deviceids.push(value.deviceId + "(" + value.sitename + ")");
      });
      this.filters('DeviceID', Deviceids[0])
      this.deviceIds = Deviceids;
      this.selectedDevice = Deviceids[0];
      console.log("Selected devuice id", this.selectedDevice)
    });
  }

  exportToPdf() {
    const docDefinition = {
      content: [
        {
          table: {
            headerRows: 1,
            widths: ['auto', 'auto', 'auto', 'auto', 'auto', 'auto'],
            body: [this.reportColumns].concat(this.reportData.map(row => Object.values(row)))
                   }
        }
      ]
    };

    pdfMake.createPdf(docDefinition).download('report.pdf');
  }
  refreshData() {
    this.ngOnInit();
}
  async filters(type: string, param: string) {
    param = param.split('(')[0];

    if (type == "DeviceID") {
      this.device = param;
      this.transMngSer.getEnergyMeters(param).toPromise().then((response: any) => {
        let energyMeterId = [];
        response.result.forEach(function (value) {
          energyMeterId.push(value.meterSerialNumber + "(" + value.assetName + ")");
        });

        energyMeterId.push("All");
        this.selectedEnergyMeter = energyMeterId[0];
        this.meterSerialNumber = energyMeterId;
        this.timeFilter = this.timeOptions[0];
        this.selectedparameter = this.parameters[0];



      });
      this.EmsdashboardService.getAlertDataReport({ "deviceid": "E002B23", "meterid": "1", "duration": "Today" }).toPromise().then((response: any) => {

        this.dataSource = new MatTableDataSource(response.result);
        this.dataSource.paginator = this.paginator;
        this.reportData=response.result;

      });

    }
    if (type == "energyMeter") {
      this.EmsdashboardService.getAlertDataReport({ "deviceid": this.device, "meterid": param, "duration": this.timeFilter }).toPromise().then((response: any) => {

        this.dataSource = new MatTableDataSource(response.result);
        this.dataSource.paginator = this.paginator;
        this.reportData=response.result;
      });
    }
if(type=="parameter")
{
  console.log("Selected Paramter is",param);
 


}
    if (type == "date") {

      let param = this.timeFilter;
      let metername = this.selectedEnergyMeter.split('(')[0];
      if (param == "Custom") {
        console.log("customa value")

        const dialogConfig = new MatDialogConfig();
        let dialogRef = this.matDialog.open(CustomDateComponent, {
          autoFocus: false,
          height: '350px', width: '450px', data: { "details": "", "action": "Add", selectedDate: this.customeSelectedDate }
        });
        dialogRef.afterClosed().subscribe(value => {
          this.startdate = value.startDate;
          this.enddate = value.endDate;

          this.EmsdashboardService.getAlertDataReport({ "deviceid": this.device, "meterid": metername, "duration": this.timeFilter, "startDate": this.startdate, "endDate": this.enddate }).toPromise().then((response: any) => {

            this.dataSource = new MatTableDataSource(response.result);
            this.dataSource.paginator = this.paginator;
            this.reportData=response.result;
          });
        });
      }
      else {
        this.EmsdashboardService.getAlertDataReport({ "deviceid": this.device, "meterid": metername, "duration": this.timeFilter }).toPromise().then((response: any) => {
          this.dataSource = new MatTableDataSource(response.result);
          this.dataSource.paginator = this.paginator;
          this.reportData=response.result;
        });
      }
    }

  }
}
